import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetCvExistQuery } from '../../../../features/user/userApiSlice';

const PostCvModal = ({ handleClose, show }) => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const { data: cvRes } = useGetCvExistQuery(name?._id, {
    skip: !name?._id,
    refetchOnMountOrArgChange: true,
  });
  const hasCv = Boolean(cvRes?.cvform || cvRes?.success);

  return (
    <div>
      <Modal aria-labelledby="contained-modal-title-vcenter" centered show={show} onHide={handleClose} animation={false}>
        <Modal.Header className='cv-modal-head border-0 p-2 text-white' closeButton>
          <Modal.Title className='fs-5'>{hasCv ? "Update Your CV" : "Post Your CV"}</Modal.Title>
        </Modal.Header>
        <div className='cv-modaal-main'>
          <p className='fs-4 pb-3 text-center w-50 fw-bold'>
            {hasCv ? "Update Your CV To Proceed" : "First Create Your Cv To Proceed"}
          </p>
          <div className='w-50 pb-3 d-flex justify-content-between'>
            <button className='cv-modal-btn1' onClick={handleClose}>
              Back
            </button>
            <button
              className='cv-modal-btn2'
              onClick={() => {
                handleClose();
                navigate('/CV-Form');
              }}
            >
              {hasCv ? "Update" : "Create"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PostCvModal;
